import Vuex from 'vuex';
import Vue from 'vue';
import events from './modules/events';
import conference from './modules/conference';
import booking from './modules/booking';
import accommodation from './modules/accommodation';
import meal from './modules/meal';
import activity from './modules/activities';
import checkout from './modules/checkout';
import currency from './modules/currency';
import resources from './modules/resources';
import total from './modules/total';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        events,
        conference,
        booking,
        accommodation,
        meal,
        activity,
        checkout,
        currency,
        resources,
        total
    }
});